import React from 'react';
import PropTypes from 'prop-types';

import {
  Dialog as DialogMui,
  DialogActions as DialogActionsMui,
  DialogContent as DialogContentMui,
  DialogTitle as DialogTitleMui,
} from '@mui/material';
import {Box, IconButton} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';

const Dialog = (props) => {
  return (
    <DialogMui
      {...props}
      fullWidth={true}
      sx={{
        'root': {
          p: {md: '8px', xs: '4px'},
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          height: '100%',
          minHeight: 0,
        }}
      >
        {props.children}
      </Box>
    </DialogMui>
  );
};
Dialog.propTypes = {
  onClose: PropTypes.func,
  children: PropTypes.node.isRequired,
};

const DialogTitle = (props) => {
  const {children, onClose, closeButtonSx, closeIconSx, ...dialogTitleProps} = props;
  return (
    <DialogTitleMui fontWeight='bold' {...dialogTitleProps}>
      {children}
      {onClose && (
        <IconButton
          aria-label='close'
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
            ...closeButtonSx,
          }}
        >
          <CloseIcon sx={closeIconSx} />
        </IconButton>
      )}
    </DialogTitleMui>
  );
};
DialogTitle.propTypes = {
  children: PropTypes.node.isRequired,
  closeButtonSx: PropTypes.object,
  closeIconSx: PropTypes.object,
  onClose: PropTypes.func,
};

export {
  Dialog,
  DialogActionsMui as DialogActions,
  DialogContentMui as DialogContent,
  DialogTitle,
};
